/*jslint white: true, plusplus: true, vars: true, undef: true, sloppy: true */
// 'use strict'

expocadfx.printTree = function( list, arr, booths) {
    var obj = {};
    var prtList = list.cloneNode( true);
    var companies = prtList.getElementsByClassName( "comp");
    var span = null;
    var i = 0;
    var k = 0;
    var index = -1;
    var arBooths;
    var bthIdx;
    var bthNum;
    var numBooths;
    var numCompanies = companies.length;
        //// style for tree
    obj.style = "div,ul,li{background:initial !important;background-color:white;color:black;}li{list-style:none;}ul{display:block !important;padding-left:20px}.booths{margin-left:30px;}.tree ul{margin-bottom:0.4em;}.tree ul li{list-style-type:square;}";
    
    prtList.style.color = "black";
    
    if( prtList.id !== "btnAv") {
        for( i = 0; i < numCompanies; i++) {
            index = companies[i].getAttribute( "data-index");
            arBooths = arr[ index].split( ",");
            numBooths = arBooths.length;
            for( k = 0; k < numBooths; k++) {
                arBooths[k] = booths[ arBooths[k] ].number;
            }
            bthNum = arBooths.join( ", ");
            span = document.createElement( "span");
            span.className = "booths";
            span.textContent = "Booth: " + bthNum;
            companies[i].appendChild( span);
        }
    }
    obj.content = prtList;
    
    return obj;
};